module.exports = __webpack_public_path__ + "img/avatar3.c92e750e.png";